// tslint:disable:max-line-length
export const environment = {
  isInMaintenanceMode: false,
  maintenanceDate: 'As of 6 am ET Tuesday, October 2 2023',
  production: true,
  logging: {
    errorTraceLogging: true,
    saveErrorToDB: true,
    saveErrorToConsoleLog: true,
    navigationTraceLog: false,
    routeGuardTraceLog: false,
    serviceCallTraceLog: false,
    serviceDataTraceLog: false,
    userTraceLog: false
  },
  appInfo: {
    appShortName: 'AccountVue',
    appLongName: 'Tuition Options AccountVue',
    appNamespace: 'com.tuitionoptions.AccountVue',
    version: '1.0',
    companyShortName: 'Tuition Options',
    companyLongName: 'Tuition Options, LLC',
    copyright: '© 2019 Tuition Options, LLC. All rights reserved'
  },
  appUrls: {
    companyHomePage: 'https://tuitionoptions.com',
    loanStatus: 'https://tuitionoptions.com/loan-status/',
    creditCalculator: 'https://www2.tuitionoptions.com/STARBorrower/calculator.aspx',
    privacyPolicy: 'https://tuitionoptions.com/privacy-policy/',
    termsConditions: 'https://tuitionoptions.com/terms-conditions/',
    browserRequirements: 'https://www.tuitionoptions.com/browser-requirements/'
  },
  device: {
    mobileHeightOffset: 185,
    iosHeightOffset: 205,
    iosOsName: 'iOS'
  },
  display: {
    mobileDisplayDialogTriggerWidth: 600,
    dialogDisplayDialogTriggerWidth: 960,
    showDisplaySize: false
  },
  assets: {
    urlPrefix: '../assets/'
  },
  user: {
    timeoutInterval: 15
  },
  restAPI: {
    useStaticUrl: false,
    staticUrl: 'https://SomeOtherHost.com/',
    urlSuffix: 'api/v1/',
    retryCount: 2,
    publicIpAddressServiceUrl: 'https://api.ipify.org?format=json',
    // reportingServiceUrl: 'Contract/EsignContract?loanCode={LOANCODE}&participantId={PARTICIPANTID}&noteId={NOTEID}',
    reportingServiceUrl: 'Contract/EsignContract/{REQUEST}',
    recaptchaSiteKey: '6LcACJEUAAAAAPQe1hAaLNtRpxIiflePGoFIYcKx'
  },
  companyCode: {
    defaultCompanyCode: 'TO',
    urlLookups: [{ urlIncludes: 'CONNECT', companyCode: 'EF' }, { urlIncludes: 'DEMO', companyCode: 'TD' }, { urlIncludes: 'MiGente', companyCode: 'T2' }],
    companyList: [{ companyName: 'Tuition Options', companyCode: 'TO' }, { companyName: 'Connect', companyCode: 'EF' }, { companyName: 'Tuition Demo', companyCode: 'TD' }, { companyName: 'Mi Gente', companyCode: 'T2' }],
    legaltext: [{ companyName: 'Tuition Options', companyCode: 'TO' }],
    allowManualCompanyCodeChange: false         // Change to False for PROD Deployment
  },
  braintree: {
    lenderProgramPriorityOne: 'TO',
    lenderProgramPriorityTwo: 'EF',
    googlePay: {
      googleMerchantId: 'BCR2DN4TXWNZRHQ5',     //'Production GooglePay Merchant Id - change to BCR2DN4TXWNZRHQ5      //'GoogleMerchant','BCR2DN4TXWNZRHQ5'
      isTestEnvironment: false,                 //'Production GooglePay Environment - change to false                 //true,
      testNonce: '',                            // Use fake-android...  in the Braintree documentation to test Backend. i.e. 'fake-android-pay-amex-nonce'
    },
    applePay: {
      version: 3,
      label: 'Single Payment',
      testNonce: ''
    }
  },
  messages: {
    defaultMessageListItemDisplayClass: 'message-normal-text'
  },
  fieldValidations: {
    payment: {
      nameMaxLength: 30,
      addressLine1MaxLength: 40,
      addressLine2MaxLength: 40,
      cityMaxLength: 25,
      zipCodeMinLength: 5,
      zipCodeMaxLength: 5,
      zipCodeMinLength_USA: 5,       // 03/15/2021 - Changed from 5 to 7
      zipCodeMaxLength_USA: 5,       // 03/15/2021 - Changed from 5 to 7
      zipCodeMinLength_CAN: 7,       // 03/15/2021 - Changed from 5 to 7
      zipCodeMaxLength_CAN: 7,       // 03/15/2021 - Changed from 5 to 7
      zipCodeMinLength_FOR: 0,       // 03/25/2021 - Changed from 5 to 7
      zipCodeMaxLength_FOR: 10,      // 03/25/2021 - Changed from 5 to 7
      creditCards: {
        visaPattern: String.raw`^4[0-9]{12}(?:[0-9]{3})?$`,
        masterCardPattern: String.raw`^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$`,
        americanExpressPattern: String.raw`^3[47][0-9]{13}$`,
        discoverPattern: String.raw`^6(?:011|5[0-9]{2})[0-9]{12}$`,
        expirationYearCount: 10
      },
      bank: {
        bankRoutingNumberMinLength: 9,
        bankRoutingNumberMaxLength: 9,
        bankAccountNumberMinLength: 4,
        bankAccountNumberMaxLength: 17
      }
    },
    contact: {
      firstNameMaxLength: 15,
      lastNameMaxLength: 15,
      middleInitialMaxLength: 1,
      addressLine1MaxLength: 40,
      addressLine2MaxLength: 40,
      cityMaxLength: 25,
      stateMaxLength: 2,
      zipCodeMinLength: 5,
      zipCodeMaxLength: 5,
      zipCodeMinLength_USA: 5,       // 02/25/2021 - Changed from 5 to 7
      zipCodeMaxLength_USA: 5,       // 02/25/2021 - Changed from 5 to 7
      zipCodeMinLength_CAN: 7,       // 02/25/2021 - Changed from 5 to 7
      zipCodeMaxLength_CAN: 7,       // 02/25/2021 - Changed from 5 to 7
      zipCodeMinLength_FOR: 0,       // 03/25/2021 - Changed from 5 to 7
      zipCodeMaxLength_FOR: 10,      // 03/25/2021 - Changed from 5 to 7
      countryMaxLength: 3,
      phonePattern: String.raw`^[0-9]+$`,
      phoneMaxLength: 10,
      emailAddressMaxLength: 80,
      // tslint:disable-next-line:max-line-length
      emailAddressPattern: String.raw`^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$`,
      securityQuestionAnswerMinLength: 1,    // 01/26/2026 RA - Added for security answer validation
      securityQuestionAnswerMaxLength: 100
    },
    userRegistration: {
      socialSecurityNumberMinLength: 9,
      socialSecurityNumberMaxLength: 9,
      socialSecurityLastFourNumberMinLength: 4,
      socialSecurityLastFourNumberMaxLength: 4,
      firstNameMaxLength: 15,
      middleInitialMaxLength: 1,
      lastNameMaxLength: 15,
      dateOfBirthMinValue: '1900-01-01',
      dateOfBirthMaxValue: null,
      userNameMinLength: 6,
      userNameMaxLength: 16,
      passwordMinLength: 8,
      passwordMaxLength: 16,
      //passwordPattern: String.raw`^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)(?=.*[@$!%*#?&]){8,16}$`,
      passwordPattern: String.raw`^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d\s'"])[^'"\s]{8,16}$`,
      userNamePattern: String.raw`^[a-zA-Z][a-zA-Z0-9]{4,50}$`,
      securityAnswerPattern: String.raw`^[a-zA-Z0-9]{1,50}$`,
      temporaryPasswordMaxLength: 256,
      securityQuestionAnswerMaxLength: 100,
      emailAddressMaxLength: 80,
      // tslint:disable-next-line:max-line-length
      emailAddressPattern: String.raw`^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$`
    }
  }
};
